import { find } from "../utils/dom";
import Swiper from "swiper";

const PageQuemSomos = () =>{
	const page = find(`[js-page='quem-somos']`);
	if(!page) return;

	const $Swipers = {
		cronologia: find('.swiper-cronologia'),
		cronologiaBackground: find('.swiper-cronologia-background'),
	}

	const $ = {
		canvasRaio: find('#canvas-raio')
	}

	const SwiperCronologia = new Swiper($Swipers.cronologia,{
		slidesPerView: 1,
		spaceBetween: 24,
		navigation:{
			nextEl: ".swiper-button-next-cronologia",
			prevEl: ".swiper-button-prev-cronologia"
		},
		pagination:{
			clickable: true,
			el: ".swiper-pagination-cronologia",
		},
		breakpoints:{
			767:{
				slidesPerView: 'auto',
				spaceBetween: 200,
			}
		}
	})

	const SwiperCronologiaBackground = new Swiper($Swipers.cronologiaBackground,{
		slidesPerView: 'auto',
		spaceBetween: 24
	})

	SwiperCronologia.controller.control = SwiperCronologiaBackground;
	SwiperCronologiaBackground.controller.control = SwiperCronologia;


	const ctx = $.canvasRaio.getContext("2d");

	function sortearInteiro(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	function desenharRaio(startX, startY, endX, endY){
    let x = startX;
    let y = startY;

    ctx.strokeStyle = "#48FF00";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x, y);


		for(let i = 1; i < endX; i++){
			if(i%4 == 0){
				ctx.lineTo(i, sortearInteiro(endY,endY+10));
			}
		}

    ctx.lineTo(endX,endY);
    ctx.stroke();
	}


	setInterval(()=>{
		ctx.clearRect(0, 0, $.canvasRaio.clientWidth, 100);
		desenharRaio(0, 50, $.canvasRaio.clientWidth, 50);
	}, 150)


	
}

export default PageQuemSomos;